import { parties } from './crosswalk';

const partyLookup = new Map(parties.map((p) => [p.key, p]));

export const partyToColour = (key: string): string => {
  return partyLookup.get(key)?.color || '#EFEFEF';
};

/**
 * `reservists`/`people_of_israel` sit in the `other` bloc, whose colour
 * (`blocColors.other`) is a near-white/pale gray — fine as a muted default
 * line, but effectively invisible as a hover highlight against the chart's
 * white background. PollChart uses this gray instead whenever one of them
 * is the actively hovered party.
 */
const hoverColourOverrides: Record<string, string> = {
  reservists: '#8b8b8b',
  people_of_israel: '#8b8b8b',
};

/** Parties projected under this many seats are drawn gray in PollChart. */
export const LOW_SEAT_THRESHOLD = 4;
const LOW_SEAT_COLOUR = '#8b8b8b';

export const partyToHoverColour = (key: string, value?: number): string => {
  if (value !== undefined && value < LOW_SEAT_THRESHOLD) return LOW_SEAT_COLOUR;
  return hoverColourOverrides[key] ?? partyToColour(key);
};

export const partyToLabel = (key: string): string => {
  return partyLookup.get(key)?.label || key;
};
